// Omit the entire captured request/response when it transports a MIRA receipt.
// This affects replay capture only, never the actual application request.
export function miraNetworkSanitizer(record) {
  try {
    const serialized = JSON.stringify(record);
    if (/correlation_receipt|x-mira-correlation-receipt/i.test(serialized)) return null;
    return record;
  } catch {
    return null;
  }
}
